export type ChatMessage = {
  id: string;
  role: string;
  content: string;
  date: string;
  feedback?: string;
  citations?: Citation[]; // Citations for assistant messages
};

export type ConversationRequest = {
  messages: ChatMessage[];
};

export type Citation = {
  part_index?: number;        // Part number for multi-part documents
  content: string;
  id: string;
  title: string | null;
  url: string | null;
  filepath: string | null;
  chunk_id: string | null;
  metadata: string | null;    // Additional metadata
  reindex_id?: string;         // Re-indexed citation number for display
};

export type ToolMessageContent = {
  citations: Citation[];
  intent?: string;
};

export type AskResponse = {
  answer: string;
  citations: Citation[];
  generated_chart: string | null;
  message_id?: string;
  feedback?: string;
  exec_results?: any[];
};

export type ChatResponse = {
  id: string;
  model: string;
  created: number;
  object: string;
  choices: {
    messages: ChatMessage[];
  }[];
};

export type Conversation = {
  id: string;
  title: string;
  date: string;
  messages: ChatMessage[];
};

export enum CosmosDBStatus {
  NotConfigured = 'CosmosDB is not configured',
  NotWorking = 'CosmosDB is not working',
  Working = 'CosmosDB is configured and working',
  InvalidCredentials = 'Invalid CosmosDB credentials',
}

export type CosmosDBHealth = {
  cosmosDB: boolean;
  status: string;
};

export enum ChatHistoryLoadingState {
  Loading = 'loading',
  Success = 'success',
  Fail = 'fail',
  NotStarted = 'notStarted',
}

export type ErrorMessage = {
  title: string;
  subtitle: string;
};

export type UserInfo = {
  access_token: string;
  expires_on: string;
  id_token: string;
  provider_name: string;
  user_claims: any[];
  user_id: string;
};

export type FrontendSettings = {
  auth_enabled: boolean;
  feedback_enabled: boolean;
  ui: {
    title: string;
    logo: string | null;
    chat_logo: string | null;
    chat_title: string;
    chat_description: string;
    show_share_button: boolean;
    show_chat_history_button: boolean;
  };
  sanitize_answer: boolean;
  oyd_enabled: string | null;
};

